// server/browser/src/lib/buildinfo.ts
//
// Single source of truth for the SPA version. Injected at build time from
// server/browser/package.json by Vite (`define: __APP_VERSION__`, see
// vite.config.ts), so there is no hand-synced literal to drift — `bun run
// bump` edits only that one JSON key and every section follows: the site
// footer, the admin console sidebar, and the Remote header. The dev server
// applies the same define, so the version is live under `bun dev` too.

declare const __APP_VERSION__: string;

/** Product version, e.g. "3.18.0". */
export const APP_VERSION = __APP_VERSION__;
